import { styled, Switch } from "@mui/material";

export const MediumMaterialUISwitch = styled(Switch)(({ theme, checked }) => ({
  width: 43,
  height: 25,
  padding: 3,

  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(0px)",

    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(16px)",

      // ✅ track when checked
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.success.main,
        opacity: 1,
      },
    },
  },

  "& .MuiSwitch-thumb": {
    width: 24,
    height: 24,

    '&::after': { content: checked ? '"ON"' : '"OFF"', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', textAlign: 'center', color: checked ? theme.palette.common.black : theme.palette.common.black, fontSize: 10, fontWeight: 'bold', lineHeight: '24px', },
  },

  // ✅ default (unchecked) track
  "& .MuiSwitch-track": {
    borderRadius: 24 / 2,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
  },
}));

export default MediumMaterialUISwitch;